export default __webpack_public_path__ + "78ef14fc265840853246528bf529d253.png";